/* PUNIVERSE build — chrome behaviour for every page: header scroll state, mobile drawer,
   footer accordions, chat launcher, and scroll reveals.

   ponytail: one file, no framework, no build step. The preview used React state and Framer
   Motion for exactly this; here it is ~80 lines of DOM. GSAP/Lenis load on the homepage only
   (ge-motion.js) — nothing on this page needs them. */
(function () {
  var doc = document;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- header: solid once scrolled past the hero. A plain scroll listener, deliberately —
     a bare ScrollTrigger.create onUpdate misses the initial state on load. ---- */
  var header = doc.querySelector('[data-ge-header]');

  /* The header is position:fixed, so everything below it needs to be pushed clear by exactly its
     height. The design hard-coded 76px; ours renders at 79 (different font metrics and icon set),
     which is why the PDP breadcrumb sat 3px under the header bar. Publish the measured height and
     let the CSS use it. */
  if (header) {
    var setHeaderHeight = function () {
      doc.documentElement.style.setProperty('--ge-header-h', header.offsetHeight + 'px');
    };
    setHeaderHeight();
    window.addEventListener('resize', setHeaderHeight, { passive: true });
    if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(setHeaderHeight);
  }

  if (header && !header.dataset.solid) {
    var onScroll = function () {
      header.classList.toggle('is-solid', window.scrollY > window.innerHeight * 0.72);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---- mobile drawer ---- */
  var burger = doc.querySelector('[data-ge-burger]');
  var mnav = doc.querySelector('[data-ge-mnav]');
  if (burger && mnav) {
    burger.addEventListener('click', function () {
      var open = !mnav.classList.contains('open');
      mnav.classList.toggle('open', open);
      mnav.setAttribute('aria-hidden', String(!open));
      burger.setAttribute('aria-expanded', String(open));
      if (header) header.classList.toggle('menu-open', open);
      doc.documentElement.style.overflow = open ? 'hidden' : '';
      // a stopped Lenis silently swallows scrollTo, so hand control back before any anchor moves
      if (!open && window.__geLenis) window.__geLenis.start();
      else if (open && window.__geLenis) window.__geLenis.stop();
    });
    mnav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        mnav.classList.remove('open');
        if (header) header.classList.remove('menu-open');
        doc.documentElement.style.overflow = '';
        if (window.__geLenis) window.__geLenis.start();
      });
    });
  }

  /* ---- footer accordions (mobile only; CSS keeps them open on desktop) ---- */
  doc.querySelectorAll('[data-ge-fcol]').forEach(function (col) {
    var btn = col.querySelector('[data-ge-fcol-btn]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var open = !col.classList.contains('is-open');
      col.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', String(open));
    });
  });

  /* ---- chat launcher ---- */
  var chat = doc.querySelector('[data-ge-chat]');
  if (chat) {
    var btn = chat.querySelector('[data-ge-chat-btn]');
    var menu = chat.querySelector('.chatl__menu');
    var toggle = function (open) {
      chat.classList.toggle('open', open);
      btn.setAttribute('aria-expanded', String(open));
      if (menu) menu.setAttribute('aria-hidden', String(!open));
    };
    btn.addEventListener('click', function () {
      toggle(!chat.classList.contains('open'));
    });
    // any "Ask Samina" button on a page can pop it open
    window.addEventListener('goldearth:chat-open', function () {
      toggle(true);
    });
  }

  /* ---- preloader: lifts on load, hard-capped so it can never trap the page ---- */
  var pre = doc.querySelector('[data-ge-preloader]');
  if (pre) {
    var lift = function () {
      pre.classList.add('is-done');
    };
    if (doc.readyState === 'complete') setTimeout(lift, 250);
    else window.addEventListener('load', function () {
      setTimeout(lift, 250);
    });
    setTimeout(lift, 2500);
  }


  /* ---- MY STORY: the BBC interview is click-to-play WITH SOUND, and pauses itself once it
     scrolls away so Samina's voice never follows the reader down the page. ---- */
  doc.querySelectorAll('[data-ge-clip]').forEach(function (clip) {
    var vid = clip.querySelector('video');
    var play = clip.querySelector('.storyp__clipPlay');
    if (!vid || !play) return;
    play.addEventListener('click', function () {
      vid.muted = false;
      vid.play().catch(function () {});
    });
    vid.addEventListener('play', function () {
      clip.classList.add('is-playing');
      vid.controls = true;
      // The overlay is position:absolute inset:0 — leaving it in place swallows every click on
      // the native controls, so the film could be started but never paused. The preview removed
      // the button from the DOM while playing; hiding it is the same thing.
      play.hidden = true;
    });
    // Once it has been started, the native controls stay: bringing the full-bleed overlay back on
    // pause would cover the resume button, which is the bug this whole block exists to fix.
    vid.addEventListener('ended', function () {
      clip.classList.remove('is-playing');
    });
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) vid.pause();
      });
    }, { rootMargin: '120px' }).observe(vid);
  });


  /* ---- Journal index: sort the aggregated feed newest-first and filter by blog ---- */
  var jgrid = doc.querySelector('[data-ge-jgrid]');
  var jfilter = doc.querySelector('[data-ge-jfilter]');
  if (jgrid && jfilter) {
    // Liquid can only walk one blog at a time, so the markup arrives grouped by blog.
    Array.prototype.slice
      .call(jgrid.children)
      .sort(function (a, b) { return (b.dataset.date | 0) - (a.dataset.date | 0); })
      .forEach(function (el) { jgrid.appendChild(el); });

    jfilter.addEventListener('click', function (e) {
      var chip = e.target.closest('.jchip');
      if (!chip) return;
      var cat = chip.dataset.cat;
      jfilter.querySelectorAll('.jchip').forEach(function (c) {
        var on = c === chip;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-pressed', String(on));
      });
      jgrid.querySelectorAll('.jcard').forEach(function (card) {
        card.hidden = cat !== 'all' && card.dataset.cat !== cat;
      });
    });
  }

  /* ---- promo bar hides once scrolled (CSS: .scrolled .promobar) ---- */
  if (doc.querySelector('.promobar')) {
    doc.body.classList.add('has-promo');
    var promoScroll = function () {
      doc.body.classList.toggle('scrolled', window.scrollY > 40);
    };
    promoScroll();
    window.addEventListener('scroll', promoScroll, { passive: true });
  }

  /* ---- in-page anchors (hero scroll cue) ---- */
  doc.querySelectorAll('[data-ge-anchor]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = doc.querySelector(a.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      if (window.__geLenis) window.__geLenis.scrollTo(target, { duration: 1.6 });
      else target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' });
    });
  });

  /* ---- testimonial carousel: arrows, dots, swipe, auto-rotate ---- */
  var voices = doc.querySelector('[data-ge-voices]');
  if (voices) {
    var figs = voices.querySelectorAll('.voice');
    var dots = voices.querySelectorAll('[data-ge-voice-dot]');
    var i = 0;
    var show = function (n) {
      i = (n + figs.length) % figs.length;
      figs.forEach(function (f, j) {
        f.classList.toggle('on', j === i);
      });
      dots.forEach(function (d, j) {
        d.classList.toggle('on', j === i);
      });
    };
    var step = function (d) {
      show(i + d);
      restart();
    };
    var timer = 0;
    var secs = parseInt(voices.dataset.rotate, 10) || 0;
    var restart = function () {
      if (timer) clearInterval(timer);
      if (secs > 0 && !reduce) timer = setInterval(function () { show(i + 1); }, secs * 1000);
    };
    var prev = voices.querySelector('[data-ge-voice-prev]');
    var next = voices.querySelector('[data-ge-voice-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    dots.forEach(function (d, j) {
      d.addEventListener('click', function () { show(j); restart(); });
    });
    var stage = voices.querySelector('.voices__stage');
    if (stage) {
      var x0 = null;
      stage.addEventListener('touchstart', function (e) {
        x0 = e.touches[0] ? e.touches[0].clientX : null;
      }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (x0 == null || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - x0;
        x0 = null;
        if (Math.abs(dx) >= 40) step(dx < 0 ? 1 : -1);
      });
    }
    show(0);
    restart();
  }

  /* ---- scroll reveals: replaces Framer Motion's whileInView on the sub-pages ---- */
  var targets = doc.querySelectorAll('[data-ge-reveal]');
  if (!targets.length) return;
  if (reduce || !('IntersectionObserver' in window)) {
    targets.forEach(function (el) {
      el.classList.add('is-in');
    });
    return;
  }
  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    },
    { rootMargin: '0px 0px -12% 0px', threshold: 0.06 }
  );
  targets.forEach(function (el) {
    io.observe(el);
  });
})();
